import { calculateHeaderGroupHeight } from '@theme/critical';
import { Component } from '@theme/component';
import { onDocumentLoaded, changeMetaThemeColor } from '@theme/utilities';

class HeaderComponent extends Component {
  requiredRefs = ['headerMenu', 'headerRowTop'];

  #resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry) return;
    const { height } = entry.target.getBoundingClientRect();
    document.body.style.setProperty('--header-height', `${height}px`);
  });

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
    document.body.style.setProperty('--header-height', '0px');
  }
}

if (!customElements.get('header-component')) {
  customElements.define('header-component', HeaderComponent);
}

onDocumentLoaded(() => {
  const header = document.querySelector('#header-component');
  const headerGroup = document.querySelector('#header-group');

  if (headerGroup) {
    const resizeObserver = new ResizeObserver(() => calculateHeaderGroupHeight(header, headerGroup));
    Array.from(headerGroup.children).forEach(child => {
      if (child instanceof HTMLElement && child !== header) resizeObserver.observe(child);
    });
    const mutationObserver = new MutationObserver(() => {
      Array.from(headerGroup.children).forEach(child => {
        if (child instanceof HTMLElement && child !== header) resizeObserver.observe(child);
      });
    });
    mutationObserver.observe(headerGroup, { childList: true });
  }
});

// MOBILE HAMBURGER
document.addEventListener('DOMContentLoaded', () => {
  const toggleButton = document.getElementById('mobile-menu-toggle');
  const menuContainer = document.getElementById('mobile-menu-container');

  if (toggleButton && menuContainer) {
    toggleButton.classList.remove('hidden'); // always show hamburger
    menuContainer.classList.add('hidden'); // start hidden

    toggleButton.addEventListener('click', () => {
      menuContainer.classList.toggle('hidden');
      toggleButton.setAttribute('aria-expanded', String(!menuContainer.classList.contains('hidden')));
    });
  }
});
